/**
 * 格式化日期
 * @param date 日期对象或日期字符串
 * @param format 格式化模式，默认为 'YYYY-MM-DD HH:mm:ss'
 * @param useIsoFormat 是否使用ISO 8601格式（如果为true，将忽略format参数）
 * @returns 格式化后的日期字符串
 */
export function formatDate(date: Date | string | number, format = 'YYYY-MM-DD HH:mm:ss', useIsoFormat = false): string {
  if (!date) return ''

  // 检查特殊日期值：0001-01-01T00:00:00Z 或 0001/01/01
  if (typeof date === 'string') {
    if (date.includes('0001-01-01') || date.includes('0001/01/01')) {
      return '-'
    }
  }

  const d = typeof date === 'object' ? date : new Date(date)

  // 检查特殊日期对象：年份为1或0
  if (d.getFullYear() <= 1) {
    return '-'
  }

  // 如果需要ISO 8601格式，则直接返回
  if (useIsoFormat) {
    return d.toISOString(); // 返回如 "2025-03-21T08:00:00.000Z" 的格式
  }

  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  const hours = d.getHours()
  const minutes = d.getMinutes()
  const seconds = d.getSeconds()

  const pad = (n: number): string => n < 10 ? `0${n}` : `${n}`

  return format
    .replace('YYYY', `${year}`)
    .replace('MM', pad(month))
    .replace('DD', pad(day))
    .replace('HH', pad(hours))
    .replace('mm', pad(minutes))
    .replace('ss', pad(seconds))
}

/**
 * 生成随机密码
 * @param length 密码长度，默认为8
 * @returns 生成的随机密码
 */
export function generateRandomPassword(length = 8): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*'
  let password = ''

  // 确保密码至少包含一个大写字母、一个小写字母和一个数字
  password += chars.charAt(Math.floor(Math.random() * 26)) // 大写字母
  password += chars.charAt(26 + Math.floor(Math.random() * 26)) // 小写字母
  password += chars.charAt(52 + Math.floor(Math.random() * 10)) // 数字

  // 填充剩余长度
  for (let i = 3; i < length; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length))
  }

  // 打乱密码顺序
  return password.split('').sort(() => 0.5 - Math.random()).join('')
}
